/* ALTON — category coverflow: scaled centre card, infinite loop.

   INPUTS: arrows (click), trackpad (wheel), drag, touch, keyboard.

   POINTER CAPTURE — read this before touching the drag code.
   setPointerCapture must NOT be called on pointerdown. Capturing redirects
   every later event, including the click, to the viewport instead of the
   <a> inside it — so the cards stop being links and nothing navigates.
   Capture is therefore only taken once movement has passed the drag
   threshold, i.e. once we know this is a drag and not a click.

   TRACKPAD — also needs care. This is a transform carousel, not a scroll
   container, so a two-finger swipe has nothing to scroll, and macOS claims
   horizontal swipes for browser back/forward before the page sees them.
   Three things make it work together:
     1. overscroll-behavior-x: contain      (coverflow-gesture.css)
     2. the viewport is a scroll container with 1px of overflow, so the
        browser routes horizontal wheels here  (coverflow-gesture.css)
     3. scrollLeft is pinned to 0 below, since that 1px must never move
*/
(function () {
  'use strict';

  var THRESHOLD = 40;      /* px of drag before it counts as a swipe  */
  var DRAG_START = 8;      /* px before a press is treated as a drag  */
  var WHEEL_STEP = 42;     /* accumulated deltaX before advancing one */
  var WHEEL_LOCK = 400;    /* ms after a step before another can fire */

  function init(section) {
    var viewport = section.querySelector('.cf-viewport');
    var track = section.querySelector('.cf-track');
    if (!viewport || !track || track.dataset.initialized) return;
    track.dataset.initialized = 'true';

    var N = parseInt(track.dataset.count, 10) || track.querySelectorAll('.cf-card').length / 3;
    var index = N;
    var animating = false;
    var fallback = null;

    function cards() { return track.querySelectorAll('.cf-card'); }

    function set(i) {
      var list = cards();
      if (!list.length) return;
      i = Math.max(0, Math.min(list.length - 1, i));
      index = i;
      list.forEach(function (c, k) {
        var d = Math.abs(k - i);
        var scale = d === 0 ? 1 : (d === 1 ? 0.9 : 0.8);
        c.style.transform = 'scale(' + scale + ')';
        c.style.opacity = String(d === 0 ? 1 : (d === 1 ? 0.92 : 0.78));
        c.style.zIndex = String(20 - d);
      });
      var active = list[i];
      var center = active.offsetLeft + active.offsetWidth / 2;
      track.style.transform = 'translateX(' + (viewport.clientWidth / 2 - center) + 'px)';
    }

    function jump(i) {
      var list = cards();
      var prevT = track.style.transition;
      track.style.transition = 'none';
      list.forEach(function (c) { c.style.transition = 'none'; });
      set(i);
      void track.offsetWidth;
      track.style.transition = prevT || '';
      list.forEach(function (c) { c.style.transition = ''; });
    }

    function normalize() {
      var norm = ((index - N) % N + N) % N + N;
      if (norm !== index) jump(norm);
    }

    function onEnd(e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      finish();
    }

    function finish() {
      clearTimeout(fallback);
      track.removeEventListener('transitionend', onEnd);
      normalize();
      animating = false;
    }

    function step(dir) {
      if (animating || N < 2) return;
      animating = true;
      normalize();
      set(index + dir);
      track.addEventListener('transitionend', onEnd);
      fallback = setTimeout(finish, 800);
    }

    /* The viewport carries 1px of scrollable overflow purely so the browser
       delivers horizontal wheel events. It must never actually scroll. */
    viewport.addEventListener('scroll', function () {
      if (viewport.scrollLeft !== 0) viewport.scrollLeft = 0;
    }, { passive: true });

    /* --- arrows --------------------------------------------------------- */
    section.addEventListener('click', function (e) {
      if (e.target.closest('[data-cf-prev]')) { e.preventDefault(); step(-1); }
      else if (e.target.closest('[data-cf-next]')) { e.preventDefault(); step(1); }
    });

    /* --- wheel / trackpad ----------------------------------------------- */
    var wheelAcc = 0;
    var wheelLockedUntil = 0;

    viewport.addEventListener('wheel', function (e) {
      var dx = e.deltaX;
      var dy = e.deltaY;

      if (e.shiftKey && Math.abs(dx) < Math.abs(dy)) dx = dy;

      /* Loose axis test: a real trackpad swipe is never perfectly
         horizontal, so requiring |dx| > |dy| rejects most genuine gestures. */
      var sideways = Math.abs(dx) > 2 && Math.abs(dx) > Math.abs(dy) * 0.5;
      if (!sideways) { wheelAcc = 0; return; }

      e.preventDefault();

      var now = Date.now();
      if (now < wheelLockedUntil) return;

      wheelAcc += dx;
      if (Math.abs(wheelAcc) >= WHEEL_STEP) {
        step(wheelAcc > 0 ? 1 : -1);
        wheelAcc = 0;
        wheelLockedUntil = now + WHEEL_LOCK;
      }
    }, { passive: false });

    /* --- drag ----------------------------------------------------------- */
    var down = false, dragging = false, suppressClick = false;
    var sx = 0, sy = 0, capturedId = null;

    cards().forEach(function (c) {
      c.setAttribute('draggable', 'false');
      c.querySelectorAll('img').forEach(function (img) {
        img.setAttribute('draggable', 'false');
      });
    });
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

    viewport.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      down = true;
      dragging = false;
      sx = e.clientX;
      sy = e.clientY;
      /* NO setPointerCapture here — see the note at the top of this file. */
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      var dy = e.clientY - sy;

      if (!dragging && Math.abs(dx) > DRAG_START && Math.abs(dx) > Math.abs(dy)) {
        dragging = true;
        /* Only now, once this is definitely a drag, is capture safe. */
        if (viewport.setPointerCapture) {
          try { viewport.setPointerCapture(e.pointerId); capturedId = e.pointerId; } catch (err) {}
        }
      }

      if (dragging && e.cancelable) e.preventDefault();
    }, { passive: false });

    function release(e) {
      if (!down) return;
      down = false;

      if (capturedId !== null && viewport.releasePointerCapture) {
        try { viewport.releasePointerCapture(capturedId); } catch (err) {}
        capturedId = null;
      }

      if (!dragging) return;              /* a plain click — let the link work */

      var dx = e.clientX - sx;
      if (Math.abs(dx) > THRESHOLD) {
        suppressClick = true;
        step(dx < 0 ? 1 : -1);
      }
      dragging = false;
    }

    viewport.addEventListener('pointerup', release);
    viewport.addEventListener('pointercancel', function () {
      down = false;
      dragging = false;
      capturedId = null;
    });
    window.addEventListener('pointerup', release);

    /* Swallow exactly one click after a real drag, so releasing does not
       also open whichever card is under the cursor. A plain click never
       sets this flag, so cards stay clickable. */
    viewport.addEventListener('click', function (e) {
      if (!suppressClick) return;
      suppressClick = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    /* --- keyboard ------------------------------------------------------- */
    viewport.setAttribute('tabindex', '0');
    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });

    window.addEventListener('resize', function () { if (!animating) jump(index); });
    requestAnimationFrame(function () { set(index); });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="coverflow"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
